import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { deleteUserRequest, deleteUserRequestError, deleteUserRequestSuccess } from "../../../slices/teams/members/DeleteUserSlice";

export const DeleteUserAPI = (id) => {
 

    const url = `${endpoints.deleteUser}/${id}`;

    return async (dispatch) => {
        try {
            dispatch(deleteUserRequest());
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
                // headers: { "Content-Type": "application/json" },
            })
            return dispatch(deleteUserRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteUserRequestError(_error));
        }
    };
};
